import { Box, Typography } from '@mui/material';

function NoRowsOverlay() {
	return (
		<Box
			sx={{
				position: 'relative',
				zIndex: 1,
				height: '100%',
				width: '100%',
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center'
			}}
		>
			<Typography variant="body1">No rows</Typography>
		</Box>
	);
}

export default NoRowsOverlay;
